<template>
  <div>
    <section v-if="this.error">
      <error-alert :error="error" />
    </section>

    <div class="panel panel-primary">
      <div class="panel-heading PanelHeadingCaption roundedcornerdiv">
        Change of Address
      </div>

      <div class="alert">
        <div class="row Q_Row row-eq-height">
          <div class="col row-flex">
            <label class="Questionniare_Label subheaderlabel"
              >Current Mailing Address</label
            >
          </div>
        </div>

        <div class="row Q_Row row-eq-height">
          <div class="col-sm-6 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex">Address 1</label>
              {{ $v.ChangeOfAddressQuestionnaire.MailingAddress1.$model }}
            </fieldset>
          </div>

          <div class="col-sm-6 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex">Address 2</label>
              {{ $v.ChangeOfAddressQuestionnaire.MailingAddress2.$model }}
            </fieldset>
          </div>
        </div>

        <div class="row Q_Row">
          <div class="col-sm-3">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label">Zip Code</label>
              {{ $v.ChangeOfAddressQuestionnaire.MailingZipCode.$model }}
            </fieldset>
          </div>

          <div class="col-sm-5">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label">City</label>
              {{ $v.ChangeOfAddressQuestionnaire.MailingCity.$model }}
            </fieldset>
          </div>

          <div class="col-sm-4">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label">State:</label>
              {{ $v.ChangeOfAddressQuestionnaire.MailingState.$model }}
            </fieldset>
          </div>
        </div>
      </div>

      <div class="alert alert-success">
        <div class="row Q_Row row-eq-height">
          <div class="col row-flex">
            <label class="Questionniare_Label subheaderlabel"
              >New Mailing Address</label
            >
          </div>
        </div>

        <div class="row Q_Row row-eq-height">
          <div class="col-sm-6 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex">Address 1</label>
              <input
                ref="changeOfAddressFirstInput"
                class="form-control form-control-lg row-flex"
                :class="{
                  'is-invalid':
                    $v.ChangeOfAddressQuestionnaire.NewMailingAddress1
                      .$invalid && this.ChangeOfAddressQuestionnaire.Submitted
                }"
                type="text"
                v-model="
                  $v.ChangeOfAddressQuestionnaire.NewMailingAddress1.$model
                "
                maxlength="30"
                placeholder
              />
              <div class="invalid-feedback">
                A street address or PO Box is required
              </div>
            </fieldset>
          </div>

          <div class="col-sm-6 row-flex">
            <fieldset class="form-group col-flex">
              <label class="Questionniare_Label row-flex">Address 2</label>
              <input
                class="form-control form-control-lg row-flex"
                style="vertical-align: bottom !important"
                type="text"
                v-model="
                  $v.ChangeOfAddressQuestionnaire.NewMailingAddress2.$model
                "
                maxlength="30"
                placeholder
              />
            </fieldset>
          </div>
        </div>

        <div class="row Q_Row">
          <div class="col-sm-3">
            <fieldset class="form-group">
              <label class="Questionniare_Label">Zip Code</label>
              <input
                class="form-control form-control-lg"
                :class="{
                  'is-invalid':
                    $v.ChangeOfAddressQuestionnaire.NewMailingZipCode
                      .$invalid && this.ChangeOfAddressQuestionnaire.Submitted
                }"
                type="text"
                v-mask="'#####'"
                v-model="
                  $v.ChangeOfAddressQuestionnaire.NewMailingZipCode.$model
                "
                placeholder
              />
              <div class="invalid-feedback">
                A valid zipcode is required
              </div>
            </fieldset>
          </div>

          <div class="col-sm-5">
            <fieldset class="form-group">
              <label class="Questionniare_Label">City</label>
              <input
                class="form-control form-control-lg"
                type="text"
                :class="{
                  'is-invalid':
                    $v.ChangeOfAddressQuestionnaire.NewMailingCity.$invalid &&
                    this.ChangeOfAddressQuestionnaire.Submitted
                }"
                v-model="$v.ChangeOfAddressQuestionnaire.NewMailingCity.$model"
                maxlength="25"
                placeholder
              />
              <div class="invalid-feedback">
                City is required
              </div>
            </fieldset>
          </div>

          <!--     <state-selection :State="$v.ChangeOfAddressQuestionnaire.NewMailingState.$model"/>-->
          <div class="col-sm-4">
            <fieldset class="form-group">
              <label class="Questionniare_Label">State:</label>
              <select
                v-model="$v.ChangeOfAddressQuestionnaire.NewMailingState.$model"
                class="form-control form-control-lg statedropdown"
                :class="{
                  'is-invalid':
                    $v.ChangeOfAddressQuestionnaire.NewMailingState.$invalid &&
                    this.ChangeOfAddressQuestionnaire.Submitted
                }"
              >
                <option value=""></option>
                <option value="AL">Alabama</option>
                <option value="AK">Alaska</option>
                <option value="AZ">Arizona</option>
                <option value="AR">Arkansas</option>
                <option value="CA">California</option>
                <option value="CO">Colorado</option>
                <option value="CT">Connecticut</option>
                <option value="DE">Delaware</option>
                <option value="DC">District Of Columbia</option>
                <option value="FL">Florida</option>
                <option value="GA">Georgia</option>
                <option value="HI">Hawaii</option>
                <option value="ID">Idaho</option>
                <option value="IL">Illinois</option>
                <option value="IN">Indiana</option>
                <option value="IA">Iowa</option>
                <option value="KS">Kansas</option>
                <option value="KY">Kentucky</option>
                <option value="LA">Louisiana</option>
                <option value="ME">Maine</option>
                <option value="MD">Maryland</option>
                <option value="MA">Massachusetts</option>
                <option value="MI">Michigan</option>
                <option value="MN">Minnesota</option>
                <option value="MS">Mississippi</option>
                <option value="MO">Missouri</option>
                <option value="MT">Montana</option>
                <option value="NE">Nebraska</option>
                <option value="NV">Nevada</option>
                <option value="NH">New Hampshire</option>
                <option value="NJ">New Jersey</option>
                <option value="NM">New Mexico</option>
                <option value="NY">New York</option>
                <option value="NC">North Carolina</option>
                <option value="ND">North Dakota</option>
                <option value="OH">Ohio</option>
                <option value="OK">Oklahoma</option>
                <option value="OR">Oregon</option>
                <option value="PA">Pennsylvania</option>
                <option value="RI">Rhode Island</option>
                <option value="SC">South Carolina</option>
                <option value="SD">South Dakota</option>
                <option value="TN">Tennessee</option>
                <option value="TX">Texas</option>
                <option value="UT">Utah</option>
                <option value="VT">Vermont</option>
                <option value="VA">Virginia</option>
                <option value="WA">Washington</option>
                <option value="WV">West Virginia</option>
                <option value="WI">Wisconsin</option>
                <option value="WY">Wyoming</option>
              </select>
              <div class="invalid-feedback">
                State is required
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  required,
  // requiredIf,
  // decimal,
  // minValue,
  // email,
  minLength
} from "vuelidate/lib/validators";

import ErrorAlert from "../components/ErrorAlert.vue";
//import StateSelection from '../components/StateSelection.vue';

export default {
  components: { ErrorAlert },
  data: () => ({
    error: ""
  }),
  props: {
    ChangeOfAddressQuestionnaire: {
      type: Object,
      required: true
    },
    CorpCode: {
      type: String,
      required: true
    },
    v: {
      type: Object,
      required: true
    }
  },
  watch: {
    "ChangeOfAddressQuestionnaire.NewMailingZipCode": function(val, preVal) {
      if (val.length == 5) {
        // console.log("looking up zipcode:", val);
        axios
          .get(
            process.env.VUE_APP_API_URL +
              "ZipCode?ZipCode=" +
              val +
              "&CorpCode=" +
              this.CorpCode
          )
          .then(response => {
            this.ChangeOfAddressQuestionnaire.NewMailingState =
              response.data[0].state;
            this.ChangeOfAddressQuestionnaire.NewMailingCity =
              response.data[0].city;
          })
          .catch(e => {
            this.error = "Error Retrieving Zip Code Lookup: " + e;
          });
      }
    }
  },
  validations: {
    ChangeOfAddressQuestionnaire: {
      MailingAddress1: {
        required
      },
      MailingAddress2: {},
      MailingZipCode: {
        required,
        minLength: minLength(5)
      },
      MailingCity: {
        required
      },
      MailingState: {
        required
      },
      NewMailingAddress1: {
        required
      },
      NewMailingAddress2: {},
      NewMailingZipCode: {
        required,
        minLength: minLength(5)
      },
      NewMailingCity: {
        required
      },
      NewMailingState: {
        required
      }
    }
  }
};
</script>
